module.exports = __webpack_public_path__ + "iPhone11-Green@2x.png?8d739fb194546f42666e3556fbce1779";